import type { ExternalStorageProvider } from '@/constants/constants-external-storage'
import { getProviderFileUrl } from '@/user_files/external-storage/ProviderMeta'

export type OpenInProviderTarget = {
  provider: ExternalStorageProvider
  url: string
}

type ExternalFileStorageLink = {
  provider: ExternalStorageProvider
  external_file_id?: string
  tombstoned: boolean
  is_externally_managed?: boolean
}

export function resolveOpenInProviderFile(externalStorage: ExternalFileStorageLink | null | undefined): OpenInProviderTarget | null {
  if (!externalStorage || externalStorage.tombstoned || externalStorage.is_externally_managed === false) return null
  if (!externalStorage.external_file_id) return null

  const url = getProviderFileUrl(externalStorage.provider, externalStorage.external_file_id)
  if (!url) return null

  return { provider: externalStorage.provider, url }
}

export function openInProviderTab(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer')
}
